import { useState, useEffect } from 'react'
import { useUser } from 'context/user/User'
import { useContainerClick } from 'context/dash/ContainerClick'
import establishmentsApi from 'api/requests/establishments'
import Loader from 'components/_UI/Loader'
import { ProductCardsContainer } from './products.styled'
import { ContentProductCard } from './products.styled'
import ProductCard from './ProductCard'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'

export default function EstablishmentsProductsList ({
    onProductClick = () => {},
    onDropdownAction = () => {},
    createProduct = () => {},
    refreshKey
}) {
    const { user } = useUser()
    const { containerClick } = useContainerClick()
    const [loading, setLoading] = useState(true)
    const [products, setProducts] = useState([])
    const [selected, setSelected] = useState(false)

    useEffect(() => {
        if (containerClick) {
            setSelected(false)
        }
    }, [containerClick])

    async function getProducts () {
        try {
            setLoading(true)

            const response= await establishmentsApi.getProducts(user?.establishments[0].slug)
                    
            setProducts(response?.data?.data)
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    function handleProductClick (product, index) {
        const editProductPayload = {
            ...product,
            action: 'edit',
            quantity: product?.batches[0]?.quantity_available,
        };

        onProductClick(editProductPayload);
        setSelected(index);
    }

    useEffect(() => {
        getProducts()
    }, [refreshKey])
    
    return (
        <>
            {
                loading ? (
                    <Loader></Loader>
                ) : products.length === 0 ? (
                    <NotResultDashBoard
                        text="Você ainda não tem produtos à venda no seu estabelecimento. Publique um produto do Geral ou crie um novo direto por aqui."
                        textButton="Adicionar produto"
                        onClick={createProduct}
                        ilustration="stock"
                    />
                ) : (
                    <ProductCardsContainer>
                        {
                            products.map((product, index)=> (
                                <ContentProductCard key={product.id}>
                                    <ProductCard
                                        data={product}
                                        onMoreClick={() => setSelected(index)}
                                        dropDownVisible={index === selected}
                                        visibleMoreAction
                                        showLiveStatus
                                        onProductClick={() => handleProductClick(product, index)}
                                        onDropdownAction={e => { onDropdownAction({ action: e, ...product}) }}
                                    />
                                </ContentProductCard>
                            ))
                        }
                    </ProductCardsContainer>
                )
            }
        </>
    )
}